import CommunityManage from "./community-manage";

export default CommunityManage;